export default "__VITE_ASSET__$fe5dSx$__"